import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { HISTORY_FEATURE_KEY, historyReducer } from './history.reducer';
import { HistoryEffects } from './history.effects';
import { HistoryEffectsV2 } from './history.effects-v2';
import { HistoryFacade } from './history.facade';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(HISTORY_FEATURE_KEY, historyReducer),
        EffectsModule.forFeature([HistoryEffects, HistoryEffectsV2]),
    ],
    providers: [HistoryFacade],
})
export class HistoryStoreModule {}
